var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11706062411581665184(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.8 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M23.5 10.9L21.3 13l-3.2 3.2-2.1 2.2-2.8 2.8-2.2 2.1-.5.5.5.5L29.8 5.6l-.5-.5-2 2V1.6c0-.2-.1-.4-.2-.5-.1-.1-.3-.2-.5-.2H2c-.2 0-.4.1-.5.2-.1.1-.2.3-.2.5v32.8c0 .2.1.4.2.5.1.1.3.2.5.2h20.1c.2 0 .4-.1.5-.2l2.3-2.2 2.2-2.2c.1-.1.2-.3.2-.5V13l-1.5 1.5v13.9h-4.6c-.2 0-.4.1-.5.2-.1.1-.2.3-.2.5v4.5H2.8V2.3h23.1v6.2l-2.4 2.4zm-1.6 19h3.9l-3.9 3.8v-3.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M6 6.1h17.7v2.1H6zM4 13h17.3l2.2-2.1H4zM4.1 18.4H16l2.2-2.2H4.1zM24.5 18.4v-2.2h-.3L22 18.4zM24.5 23.3v-2.2h-5.3L17 23.3zM4.1 23.3H11l2.2-2.2H4.1zM8.2 28.3v-.2l1.1-2H4.1v2.2zM12.9 27.3l-2.1 1h8.6v-2.2h-5.2l-.7.7-.5-.5-.2-.2h-.6l.7.7c.1.1.1.2.1.2.1.1 0 .2-.1.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M25.8 29.9h-3.9v3.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.5 10.9l2.4-2.4V2.3H2.8v31.3h17.7v-4.5c0-.2.1-.4.2-.5.1-.1.3-.2.5-.2h4.6V14.5l1.5-1.5 5-5-9.2 9.2 1.1-1.1h.3v2.2H22l-8.4 8.4.7-.7h5.2v2.2h-8.6l-1.6.8-1.3.7c-.1.1-.2 0-.3-.1-.1-.1-.1-.2-.1-.3l.5-1h-4v-2.2h5.2l.8-1.7c0-.1.1-.1.2-.1s.2 0 .2.1l1.8 1.8h.6l.2.2L31.7 7.6l-2-2-18.6 18.7-.5-.5.5-.5h-7v-2.2h9.1l2.8-2.8H4.1v-2.2h14.1l3.2-3.2H4v-2.1h19.5zM6 6.1h17.7v2.1H6V6.1zm11 17.2l2.2-2.2h5.3v2.2H17zM30 6l1.3 1.3L12.7 26l-1.3-1.3L30 6zM22 18.4l1.1-1.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M31.356 7.244L12.618 25.982l-1.344-1.343L30.012 5.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M13.5 26.8L32.2 8.1l-.5-.5L13 26.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M10.5 24.3c-.1-.1-.2-.1-.2-.1-.1 0-.2.1-.2.1L9.3 26l-1 2 1 1 1.6-.8 2.1-1c.1 0 .1-.1.1-.2s0-.2-.1-.2l-.7-.7-1.8-1.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M7.7 29.3c-.1.1 0 .2.1.3.1.1.2.1.3.1l1.2-.6-1-1-.1.1-.5 1.1zM31.1 3.3l-.3.3-.6.6-.6.6 3 3 .6-.6.6-.6.3-.3c.8-.8.8-2.2 0-3-.9-.8-2.2-.8-3 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11706062411581665184);
export default __webpack_public_path__ + "static/media/11706062411581665184.d41f18db97381a2ee42516b9870f6230.svg";
export { ForwardRef as ReactComponent };